/* eslint-disable */

const Amplitude = {
  Home: {
    events: {
      funcionalitySelected: 'Funcionalidad Seleccionada',
      loanIntention: 'Intención de Préstamo'
    },
    properties: {
      myInsurance: 'Mis Seguros',
      profile: 'Mis Datos',
      vivemas: 'Vive+',
      loans: 'Prestamos',
      formalities: 'Atención al Cliente',
      moreInsurance: 'Mas seguros para ti',
      cvc: 'Cambio Vida de Cobro',
      pagoCuotas: 'Pago de Cuotas',
      emergency: 'Emergencias',
      contactUs: 'Contáctanos'
    }
  },
  PaymentMethodChange: {
    events: {
    },
    properties: {
    }
  },
  PaymentQuotes: {
    events: {
      intencion: 'Intención Pago Seguro',
      resumen: 'Resumen de Pago',
      formulario: 'Confirmación de Pago',
      errorLoadNiubiz: 'Error formuario Niubiz',
      pago: 'Pago Exitoso'
    },
    properties: {
      producto: 'Producto Consultado',
      subproducto: 'Sub Producto Consultado',
      poliza: 'Poliza',
      estado: 'Estado',
      cantidad: 'Cantidad de cuotas',
      frecuenciaPago: 'Frecuencia de pago',
      cuotas: 'Selección de cuota',
      monto: 'Monto total a pagar',
      tipoTarjeta: 'Tipo de tarjeta',
      opcionFormulario: 'Opcion de formulario',
    }
  }
}


export default Amplitude



// WEBPACK FOOTER //
// ./src/interfaces/amplitudeData.js